import React, { useCallback } from 'react';
import { AppButton, Box, SearchInput, SelectDropdown } from '@common-fe/common-fe';

import { ALL_OPTION } from '@/common/constants';
import { Option, OptionKey } from '@/common/types';

import { CATEGORIES_OPTIONS, SERVICE_TYPES_OPTIONS } from '../EligibleServices.constants';

import { useSpendLimitsModalStore } from './SpendLimitsModal/stores';

interface Props {
  sortParams: OptionKey | null;
  sortOptions: Option[];
  searchString: string;
  setSearchString: (value: string) => void;
  setSortParams: (key: OptionKey) => void;
  serviceTypeParamsValues: OptionKey[];
  setServiceType: (key: OptionKey[]) => void;
  categoriesParamsValues: OptionKey[];
  setCategories: (key: OptionKey[]) => void;
  isPerCategorySpendLimit?: boolean;
  isEditMode?: boolean;
}

const ControlPanel: React.FC<Props> = ({
  sortParams,
  sortOptions,
  searchString,
  setSearchString,
  setSortParams,
  serviceTypeParamsValues,
  setServiceType,
  categoriesParamsValues,
  setCategories,
  isPerCategorySpendLimit,
  isEditMode,
}) => {
  const handleChangeVisibility = useSpendLimitsModalStore((state) => state.handleChangeVisibility);

  const handleOpenSpendLimits = useCallback(() => {
    handleChangeVisibility(true);
  }, [handleChangeVisibility]);

  return (
    <Box direction="row" align="center" height="40px" gap="s">
      <Box width={{ max: isPerCategorySpendLimit ? '170px' : '230px', min: '170px'}}>
        <SearchInput
          testId="eligible-services"
          value={searchString}
          hasSearchingHistory
          placeholder="Search"
          onChange={setSearchString}
          resetValue={searchString}
        />
      </Box>
      <Box width={isPerCategorySpendLimit ? '170px' : '200px'}>
        <SelectDropdown
          id="categories"
          allMode
          testId="CategoriesList"
          ellipsisMode
          activeTitle
          name="Categories"
          prefix="Category"
          options={[ALL_OPTION, ...CATEGORIES_OPTIONS]}
          values={categoriesParamsValues}
          onChangeValues={setCategories}
        />
      </Box>
      <Box width={isPerCategorySpendLimit ? '140px' : '180px'}>
        <SelectDropdown
          id="type"
          allMode
          testId="TypeList"
          ellipsisMode
          activeTitle
          name="Type"
          prefix="Type"
          options={[ALL_OPTION, ...SERVICE_TYPES_OPTIONS]}
          values={serviceTypeParamsValues}
          onChangeValues={setServiceType}
        />
      </Box>
      <Box width="150px">
        <SelectDropdown
          id="status"
          singleMode
          testId="processing-rules-sort-by"
          ellipsisMode
          activeTitle
          name="Sort by"
          prefix="Sort by"
          options={sortOptions}
          value={sortParams}
          onChange={setSortParams}
        />
      </Box>
      {(isPerCategorySpendLimit && isEditMode) ? (
        <Box>
          <AppButton
            onClick={handleOpenSpendLimits}
          >
            Spend Limits
          </AppButton>
        </Box>
      ) : null}
    </Box>
  );
};

export default ControlPanel;
